export const favoritesSelector = (state) => state.favorites.list;
export const favoritesIdsSelector = (state) => state.favorites.ids;
